import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import '../src/assets/styles/global.scss';
import '../src/assets/styles/airports.scss';
import App from './App';
import "antd/dist/reset.css";
import { SpinProvider } from './components/SpinContext';
import Spinner from './components/Spinner';
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from '../src/reudx-toolkit/store';
import { WebSocketProvider } from './context/WebSocketContext';
import { init as initFullStory } from '@fullstory/browser';

initFullStory({ orgId: 'o-22MP9G-na1',host:'metrics.zoomlogi.com',script:'metrics.zoomlogi.com/s/fs.js',appHost:'app.fullstory.com' });

const RootComponent = () => {
    const [selectedUserID, setSelectedUserID] = useState(null); 

    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <WebSocketProvider selectedUserID={selectedUserID}>
                    <SpinProvider>
                        <Spinner />
                        <App setSelectedUserID={setSelectedUserID} />
                    </SpinProvider>
                </WebSocketProvider>
            </PersistGate>
        </Provider>
    );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RootComponent />);
